@if (totalPages() > 1) {
  <!-- Header -->
  <h3 class="tw-sr-only" [id]="id">
    {{ i18n().Pagination_AriaTarget }}
  </h3>

  <nav
    [attr.aria-labelledby]="id"
    class="tw-relative tw-flex tw-h-16 tw-flex-col tw-items-center tw-gap-5 tw-px-6 md:tw-flex-row md:tw-justify-between xl:tw-justify-start"
  >
    <!-- Summary -->
    <div class="tw-flex-basis-full tw-text-xs tw-font-normal">
      {{ i18n().Pagination_ResultsOverview }}
    </div>

    <!-- Pagination nav -->
    <ul
      class="tw-flex tw-items-center tw-gap-1 tw-text-xs xl:tw-absolute xl:tw-left-[50%] xl:tw-translate-x-[-50%]"
    >
      <!-- << first page-->
      <ng-container
        *ngTemplateOutlet="
          pagenav;
          context: {
            disabled: pageIndex() === 1,
            page: 1,
            label: i18n().Pagination_FirstPage,
            icon: 'chevron-double-left',
          }
        "
      />

      <!-- < previous page -->
      <ng-container
        *ngTemplateOutlet="
          pagenav;
          context: {
            disabled: pageIndex() === 1,
            page: previousPage(),
            label: i18n().Pagination_PreviousPage,
            icon: 'chevron-left',
          }
        "
      />

      <!-- Page #s & '...' -->
      @for (page of pages(); track $index) {
        <li>
          @if (page !== -1) {
            <button
              type="button"
              class="tw-flex tw-h-6 tw-items-center tw-justify-center tw-rounded-lg tw-px-2"
              [ngClass]="{
                'tw-bg-neutral-200 tw-font-semibold': pageIndex() === page,
                'tw-text-neutral-800 hover:tw-bg-neutral-100 active:tw-bg-neutral-200':
                  pageIndex() !== page,
              }"
              [attr.aria-selected]="pageIndex() === page ? 'true' : null"
              [attr.aria-label]="
                'Pagination_PageNumber' | translate: { number: page }
              "
              (click)="showPage($event, page)"
            >
              {{ page }}
            </button>
          } @else {
            <span
              class="tw-flex tw-h-6 tw-w-6 tw-items-center tw-justify-center tw-rounded-lg"
            >
              <da-icon
                icon="ellipsis-horizontal"
                type="outline"
                className="tw-size-4 tw-text-neutral-800"
                aria-hidden="true"
              />
            </span>
          }
        </li>
      }

      <!-- next page > -->
      <ng-container
        *ngTemplateOutlet="
          pagenav;
          context: {
            disabled: pageIndex() === totalPages(),
            page: nextPage(),
            label: i18n().Pagination_NextPage,
            icon: 'chevron-right',
          }
        "
      />

      <!-- last page >> -->
      <ng-container
        *ngTemplateOutlet="
          pagenav;
          context: {
            disabled: pageIndex() === totalPages(),
            page: totalPages(),
            label: i18n().Pagination_LastPage,
            icon: 'chevron-double-right',
          }
        "
      />
    </ul>
  </nav>
}

<ng-template
  #pagenav
  let-disabled="disabled"
  let-page="page"
  let-label="label"
  let-icon="icon"
>
  <li>
    <button
      type="button"
      class="tw-flex tw-h-6 tw-w-6 tw-items-center tw-justify-center tw-rounded-lg"
      [ngClass]="{
        'tw-cursor-not-allowed tw-text-neutral-400': disabled,
        'tw-text-neutral-800 hover:tw-bg-neutral-100 active:tw-bg-neutral-200':
          !disabled,
      }"
      [attr.aria-disabled]="disabled"
      [attr.aria-label]="label"
      (click)="showPage($event, page)"
    >
      <da-icon
        [icon]="icon"
        type="outline"
        className="tw-size-4"
        aria-hidden="true"
      />
    </button>
  </li>
</ng-template>
